import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSite } from '../context/SiteContext';
import '../assets/LegalPage.css';

const ShippingPolicy = () => {
  const { siteName, fullAddress, email, phone } = useSite();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const effectiveDate = 'March 19, 2025';
  const lastUpdated = 'March 19, 2025';

  return (
    <div className="legal-page">
      <div className="legal-container">
        <header className="legal-header">
          <h1>Shipping Policy</h1>
          <p className="legal-meta">
            Effective Date: {effectiveDate} | Last Updated: {lastUpdated}
          </p>
        </header>

        <div className="legal-content">
          <section className="legal-section">
            <h2>1. Overview</h2>
            <p>
              {siteName} offers shipping throughout the contiguous United States, Alaska, Hawaii, and U.S. territories. We partner with reliable carriers including UPS, FedEx, and the United States Postal Service (USPS) to deliver your orders. This policy outlines our shipping methods, timeframes, and costs.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Shipping Methods and Timeframes</h2>
            <h3>Standard Shipping (5–7 Business Days)</h3>
            <p>
              Free on orders of $49 or more. Orders under $49 incur a flat rate of $9.99. Delivery typically occurs within 5–7 business days from the date of shipment. Business days exclude weekends and federal holidays.
            </p>
            <h3>Express Shipping (2–3 Business Days)</h3>
            <p>
              $14.99 flat rate. Delivery typically occurs within 2–3 business days from the date of shipment.
            </p>
            <h3>Next-Day Shipping (1 Business Day)</h3>
            <p>
              $24.99 flat rate. Available for most items when ordered before 2:00 PM ET. Delivery occurs the next business day. Not available for all products or destinations.
            </p>
            <p>
              <strong>Note:</strong> Processing time is 1–2 business days after order placement. Total delivery time = processing time + shipping time. Delivery dates are estimates and not guaranteed.
            </p>
          </section>

          <section className="legal-section">
            <h2>3. Shipping to Alaska, Hawaii, and U.S. Territories</h2>
            <p>
              Additional shipping charges and extended delivery times may apply for orders shipped to Alaska, Hawaii, Puerto Rico, Guam, the U.S. Virgin Islands, and other U.S. territories. Next-day shipping is not available to these destinations. You will see applicable charges at checkout.
            </p>
          </section>

          <section className="legal-section">
            <h2>4. Order Processing</h2>
            <p>
              Orders placed Monday–Friday before 2:00 PM ET are typically processed the same day. Orders placed after 2:00 PM ET or on weekends/holidays are processed the next business day. You will receive an email confirmation with tracking information once your order ships.
            </p>
          </section>

          <section className="legal-section">
            <h2>5. Tracking Your Order</h2>
            <p>
              Once your order ships, you will receive an email with a tracking number and carrier link. You can also track your order by logging into your account and visiting the order history section. Please allow up to 24 hours for tracking information to become active after shipment.
            </p>
          </section>

          <section className="legal-section">
            <h2>6. Delivery Issues</h2>
            <p>
              If your package is lost, damaged in transit, or not delivered by the estimated date, please contact us within 30 days of the shipment date. We will work with the carrier to resolve the issue and may offer a replacement or refund. Claims for lost or damaged packages must be reported promptly.
            </p>
          </section>

          <section className="legal-section">
            <h2>7. Undeliverable Packages</h2>
            <p>
              If a package is returned to us due to an incorrect address, refusal of delivery, or failure to pick up from a carrier location, we will contact you. You may be responsible for additional shipping charges to reship. If we cannot reach you, the order may be cancelled and refunded minus any restocking or return shipping fees.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. International Shipping</h2>
            <p>
              We currently ship only within the United States and its territories. We do not offer international shipping at this time.
            </p>
          </section>

          <section className="legal-section">
            <h2>9. Contact Us</h2>
            <p>
              For questions about shipping, please contact us:
            </p>
            <ul className="legal-contact">
              <li><strong>{siteName}</strong></li>
              <li>{fullAddress}</li>
              <li>Email: <a href={`mailto:${email}`}>{email}</a></li>
              <li>Phone: <a href={`tel:${phone}`}>{phone}</a></li>
            </ul>
          </section>
        </div>

        <div className="legal-footer-links">
          <Link to="/">Return to Home</Link>
          <Link to="/terms">Terms of Use</Link>
          <Link to="/returns">Returns Policy</Link>
          <Link to="/contact">Contact Us</Link>
        </div>
      </div>
    </div>
  );
};

export default ShippingPolicy;
